'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Breadcrumb from 'Components/Front/Breadcrumb';
import CustomerBookingRow from 'Components/Lists/Rows/CustomerBooking';
import Dashboard from 'Components/Lists/Dashboard';
import bemit from 'Functions/bemit';
const app = window.app;
import { URL, action } from 'Shared/Routes';
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Mes réservations',
  url: URL('CustomerBookingsDashboard')
}];
const header = [{
  name: 'date',
  label: 'Date',
  sortable: false
}, {
  name: 'hours',
  label: 'Horaires',
  sortable: false
}, {
  name: 'amount',
  label: 'Montant',
  sortable: false
}, {
  name: 'coworking_space.name',
  label: 'Espace / Etablissement',
  sortable: false
}, {
  name: 'address',
  label: 'Adresse',
  sortable: false
}, {
  name: 'number_of_people',
  label: 'Nombre de personnes',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}, {
  name: 'PDF',
  label: 'PDF',
  sortable: false
}, {
  name: 'actions',
  sortable: false
}];
const fields = header.map(infos => infos.name);
export default class CustomerBookingsDashboardPage extends Component {
  state = {
    customer_id: app.state.session.user?.id
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session.fetched) {
      component.handleSessionChange({
        source: 'DidMount'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      customer_id: app.state.session.user?.id
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let filters = {
      user_id: state.customer_id
    };
    const content = filters.user_id ? /*#__PURE__*/React.createElement(Dashboard, {
      model: "Booking",
      url: action('getAllBookings'),
      header: header,
      fields: fields,
      component: CustomerBookingRow,
      "items-per-page": 30,
      filters: filters,
      empty_txt: "Vous retrouverez vos prochaines r\xE9servations ici"
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: "Mes r\xE9servations",
      meta_follow: false
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['static-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "Mes r\xE9servations")))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page cutomer-bookings"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), content));
    return output;
  }
}
